import type { ShopMessageKey } from '../../../i18n'
import { CustomerAreaSurfaceCard } from '../customer-area'

type TranslateFn = (key: ShopMessageKey, params?: Record<string, string | number>) => string

type CustomerProfileFormState = {
  firstName: string
  lastName: string
  email: string
  phone: string
  taxCode: string
  residentialAddress: string
}

type CustomerProfileFormCardProps = {
  formState: CustomerProfileFormState
  saving: boolean
  hasChanges: boolean
  notice: string
  t: TranslateFn
  onChangeField: (field: keyof CustomerProfileFormState, value: string) => void
  onSave: () => void
}

export const CustomerProfileFormCard = ({
  formState,
  saving,
  hasChanges,
  notice,
  t,
  onChangeField,
  onSave,
}: CustomerProfileFormCardProps) => (
  <CustomerAreaSurfaceCard
    title={t('customer.profile.formTitle')}
    subtitle={t('customer.profile.formSubtitle')}
  >
    <div className="grid gap-3 md:grid-cols-2">
      <label className="grid gap-1 text-sm text-(--color-text-secondary)">
        <span className="font-medium">{t('customer.dashboard.firstName')}</span>
        <input
          value={formState.firstName}
          onChange={(event) => onChangeField('firstName', event.target.value)}
          className="ca-input ca-theme-transition px-3 py-2 text-sm"
        />
      </label>
      <label className="grid gap-1 text-sm text-(--color-text-secondary)">
        <span className="font-medium">{t('customer.dashboard.lastName')}</span>
        <input
          value={formState.lastName}
          onChange={(event) => onChangeField('lastName', event.target.value)}
          className="ca-input ca-theme-transition px-3 py-2 text-sm"
        />
      </label>
      <label className="grid gap-1 text-sm text-(--color-text-secondary)">
        <span className="font-medium">{t('customer.auth.email')}</span>
        <input
          type="email"
          value={formState.email}
          onChange={(event) => onChangeField('email', event.target.value)}
          className="ca-input ca-theme-transition px-3 py-2 text-sm"
        />
      </label>
      <label className="grid gap-1 text-sm text-(--color-text-secondary)">
        <span className="font-medium">{t('customer.dashboard.phone')}</span>
        <input
          value={formState.phone}
          onChange={(event) => onChangeField('phone', event.target.value)}
          className="ca-input ca-theme-transition px-3 py-2 text-sm"
        />
      </label>
      <label className="grid gap-1 text-sm text-(--color-text-secondary)">
        <span className="font-medium">{t('customer.dashboard.taxCode')}</span>
        <input
          value={formState.taxCode}
          onChange={(event) => onChangeField('taxCode', event.target.value)}
          className="ca-input ca-theme-transition px-3 py-2 text-sm uppercase"
        />
      </label>
      <label className="grid gap-1 text-sm text-(--color-text-secondary) md:col-span-2">
        <span className="font-medium">{t('customer.dashboard.residentialAddress')}</span>
        <input
          value={formState.residentialAddress}
          onChange={(event) => onChangeField('residentialAddress', event.target.value)}
          className="ca-input ca-theme-transition px-3 py-2 text-sm"
        />
      </label>
    </div>
    <div className="mt-4 flex flex-wrap items-center gap-2.5">
      <button
        type="button"
        onClick={onSave}
        disabled={!hasChanges || saving}
        className="ca-btn-primary inline-flex items-center px-4 py-2 text-sm font-semibold disabled:cursor-not-allowed disabled:opacity-60"
      >
        {saving ? t('customer.profile.saving') : t('customer.profile.save')}
      </button>
      {notice ? <span className="text-sm text-(--color-text-secondary)">{notice}</span> : null}
    </div>
  </CustomerAreaSurfaceCard>
)
